import React from 'react'
import ConactUsHeader from '../organisms/ContactUsHeader'
import TermsBody from '../organisms/TermsBody'
import Footer from '../organisms/Footer'
import useScrollToTop from '../../hooks/useScrollToTop'
const TermsPage = () => {
  useScrollToTop()
  return (
    <div className='bg-gray-100'>
      <ConactUsHeader />
      <TermsBody />
      <Footer />
    </div>
  )
}

export default TermsPage
